// 알림 버튼 공통 컴포넌트 — createPortal 기반 툴팁
import React, { useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import './AlertButton.css';

const AlertButton = ({
  hasAlert, alertEnabled, alertTypeNameUp, alertTypeNameDown, onClick,
  onColor,   // 활성 상태(ab-on) 아이콘 색상 override (미지정 시 기본 파랑 유지)
  upExtra,   // 상승 툴팁에 유형명 뒤에 덧붙일 텍스트 (예: 목표가)
  downExtra, // 하락 툴팁에 유형명 뒤에 덧붙일 텍스트
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPos, setTooltipPos]   = useState({ top: 0, left: 0 });
  const wrapRef = useRef(null);

  let cls, icon;
  if (!hasAlert)        { cls = 'ab-none'; icon = '🔔'; }
  else if (!alertEnabled) { cls = 'ab-off';  icon = '🔕'; }
  else                    { cls = 'ab-on';   icon = '🔔'; }

  const enableIcon  = alertEnabled ? '🟢' : '⚪';
  const tooltipText = hasAlert
    ? [
        alertTypeNameUp   ? `📈 상승: ${alertTypeNameUp}${upExtra ? ' ' + upExtra : ''} ${enableIcon}`     : '📈 상승: 미설정',
        alertTypeNameDown ? `📉 하락: ${alertTypeNameDown}${downExtra ? ' ' + downExtra : ''} ${enableIcon}` : '📉 하락: 미설정',
      ].join('\n')
    : null;

  const handleMouseEnter = () => {
    if (!hasAlert || !wrapRef.current) return;
    const rect = wrapRef.current.getBoundingClientRect();
    setTooltipPos({ top: rect.bottom + 4, left: rect.left });
    setShowTooltip(true);
  };

  return (
    <span
      className="ab-wrap"
      ref={wrapRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <button
        className={`ab-btn ${cls}`}
        style={cls === 'ab-on' && onColor ? { color: onColor } : undefined}
        title={!hasAlert ? '알림 미설정 — 클릭하여 설정' : undefined}
        onClick={(e) => { e.stopPropagation(); onClick?.(); }}
      >
        {icon}
      </button>
      {showTooltip && tooltipText && createPortal(
        <div style={{
          position:     'fixed',
          top:          tooltipPos.top,
          left:         tooltipPos.left,
          background:   '#FFFFFF',
          color:        '#333333',
          border:       '1px solid #DDDDDD',
          padding:      '8px 12px',
          borderRadius: '6px',
          fontSize:     '12px',
          lineHeight:   '1.8',
          whiteSpace:   'pre-line',
          boxShadow:    '0 2px 8px rgba(0,0,0,0.15)',
          pointerEvents:'none',
          minWidth:     '180px',
          zIndex:       99999,
        }}>
          {tooltipText}
        </div>,
        document.body
      )}
    </span>
  );
};

export default AlertButton;
